import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import {ForgotPassword} from 'app/modules/auth/components/ForgotPassword'
import {ResetPassword} from 'app/modules/auth/components/ResetPassword'
import {OnlineApplication} from 'app/modules/online-application/OnlineApplication'
import {AccountVerification} from 'app/modules/auth/components/AccountVerifcation'
import {OnlineKankor} from 'app/modules/online-application/OnlineKankor'
import {AJOnlineApp} from 'app/modules/online-application/AJOnlineApp'
import {AJOnlineKankor} from 'app/modules/online-application/AJOnlineKankor'
import GenevaCourseApplication from 'app/modules/oc-registration/GenevaCourseApplication'
import SenegalCourseApplication from 'app/modules/oc-registration/SenegalCourseApplication'
import CoteCourseApplication from 'app/modules/oc-registration/CoteCourseApplication'
import EGACourseApplication from 'app/modules/oc-registration/EGACourseApplication'

const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='forgot-password' element={<ForgotPassword />} />
          <Route path='account-activation' element={<AccountVerification />} />
          <Route path='online-application' element={<OnlineApplication />} />
          <Route path='entrance-exam-application' element={<OnlineKankor />} />
          <Route path='reset-password/:token' element={<ResetPassword />} />
          {/* abidjan campus online application */}
          <Route path='aj-online-app' element={<AJOnlineApp />} />
          <Route path='aj-entrance-exam-app' element={<AJOnlineKankor />} />
          {/* online course application */}
          <Route path='gva-apply-course' element={<GenevaCourseApplication />} />
          <Route path='ci-apply-course' element={<CoteCourseApplication />} />
          <Route path='sn-apply-course' element={<SenegalCourseApplication />} />
          <Route path='ega-apply-course' element={<EGACourseApplication />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
